import stringHelper from "../../Helpers/stringHelper";
import urlHelper from "../../Helpers/urlHelper";

export default class LineItemCreditItem {
  constructor(item) {
    this.initialize(item);
    this.Selected = false;
  }

  async initialize(item) {
    this.ApolloId = item.apolloId;
    this.LineItemCreditId = item.lineItemCreditId;
    this.Name = item.name;
    this.InitDue = item.initDue;
    this.Paid = item.paid;
    this.CurrencySymbol = item.currencySymbol;
    this.InitialTotalFormatted = stringHelper.getValueWithSymbol("", this.CurrencySymbol, this.InitDue);
    this.CreditAmountVat = item.creditAmountVat;
    this.CreditAmountVatFormatted = stringHelper.getValueWithSymbol("", this.CurrencySymbol, this.CreditAmountVat);
    this.Type = item.type;
    this.LineItemId = item.lineItemId;
    this.CreditAmountVatreimb = item.creditAmountVatreimb;
    this.CreditAmountVatreimbFormatted = stringHelper.getValueWithSymbol("", this.CurrencySymbol, this.CreditAmountVatreimb);
    this.CreditAmount = item.creditAmount;
    this.CreditAmountFormatted = stringHelper.getValueWithSymbol("", this.CurrencySymbol, this.CreditAmount);
    this.CreditAmountReimb = item.creditAmountReimb;
    this.CreditAmountReimbFormatted = stringHelper.getValueWithSymbol("", this.CurrencySymbol, this.CreditAmountReimb);
  }

  static NameOfTheIdField() {
    return "CreditMemoNumber";
  }
  static nameOfTheItemDetailList() {
    return "Credit Memo";
  }
  static MoneyFields = ["InitDue", "Paid"];
  static Currency() {
    return "CurrencySymbol";
  }
  static MoneyFieldsSecondary = [];
  static CurrencySecondary() {
    return "";
  }
  static DateFields = [];
  static BoolFields = [];

  static FieldsToShowInListTable = [
    {
      tabName: "Info",
      tabLabel: "Info",
      icon: "fa-solid fa-info",
      data: [{ label: "BARE #", name: "CreditMemoNumber", className: "text-left" }],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      { label: "Line Credit ID", orderById: "LineItemCreditId", data: "LineItemCreditId" },
      { label: "Apollo ID", orderById: "ApolloId", data: LineItemCreditItem.GetDetailCellContent },
      { label: "Location", orderById: "Name", data: "Name" },
      { label: "Fee Credit", orderById: "CreditAmount", data: "CreditAmountFormatted" },
      { label: "Reimb. Credit", orderById: "CreditAmountReimb", data: "CreditAmountReimbFormatted", minWidth: 90 },
      { label: "Fee Tax Credit", orderById: "CreditAmountVat", data: "CreditAmountVatFormatted" },
      { label: "Reimb. Tax Credit", orderById: "CreditAmountVatreimb", data: "CreditAmountVatreimbFormatted", minWidth: 105 },
      { label: "Initial Total", orderById: "InitDue", data: "InitialTotalFormatted" },
      { label: "Type", orderById: "Type", data: "Type" },
      { label: "Line Item ID", orderById: "LineItemId", data: "LineItemId" },
    ];
  }

  static GetDetailCellContent(item) {
    return urlHelper.getIconLinkComponentFigma(
      item.ApolloId,
      "fa-solid fa-arrow-up-right-from-square",
      "text-primary pl-1 pr-1",
      "assignments/search",
      "AsSassieAsgnId=" + item.ApolloId,
      "Open up in a new tab"
    );
  }
}
